const data: any[]  = [
    { label: '25%', value: 25.00 },
    { label: '12%', value: 12.00 },
    { label: '6%', value: 6.00 },
    { label: 'Momsfritt', value: 0.00 },
];
export default data;
